import React, {Fragment} from 'react'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {urls} from 'lib/urls'
import fetchJSON from 'lib/fetchJSON'
import {copyToClipboard} from 'lib/copyToClipboard'
import {CTA} from 'common/styleguide/CTA'
import {CircleSpinner} from 'common/spinners'
import {Icon} from 'common/Icon'
import styles from './ShareModal.scss'

export const SHARE_MODAL = 'SHARE_MODAL'

// share via email params:
// POST /share.json with
// share[model]: route
// share[id]: 27176252
// share[url]: https://ridewithgps.com/routes/27176252
// share[email]: qrohlf@gmail.com

const EMBEDDABLES = ['route', 'trip', 'event']

export class ShareModal extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      interaction: null,
      copySuccess: null
    }
  }

  onClickEmail = (e) => {
    e.preventDefault()
    this.setState({interaction: 'email_input'})
  }

  onClickCopy = (e) => {
    const {objectUrl} = this.props
    e.preventDefault()
    this.setState({copySuccess: false}, () => {
      copyToClipboard('https://ridewithgps.com' + objectUrl)
        .then(() => this.setState({copySuccess: true}))
    })
  }

  render () {
    const {onRequestClose, objectType, objectId, objectTitle, objectUrl, privacyCode, overlayTitle} = this.props
    const {interaction, copySuccess} = this.state

    if (interaction === 'email_input') {
      return <ModalOverlay
        title={<Fragment>Share <strong>{objectTitle}</strong></Fragment>}
        maxWidth='400px'
        onRequestClose={onRequestClose}>
        <EmailShare type={objectType} id={objectId} url={objectUrl} />
      </ModalOverlay>
    }

    return (
      <ModalOverlay
        title={overlayTitle || <Fragment>Share <strong>{objectTitle}</strong></Fragment>}
        maxWidth='400px'
        onRequestClose={onRequestClose}>
        <div className={styles.ShareModal}>

          <div className={styles.shareIcons}>
            <a
              className={styles.icon}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://facebook.com/sharer.php?u=${encodeURIComponent('https://ridewithgps.com' + objectUrl)}&t=${encodeURIComponent(objectTitle)}`}>
              <Icon i={'facebook-icon'} title={'Share on Facebook'} />
            </a>
            <a
              className={styles.icon}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://twitter.com/home?status=${encodeURIComponent('https://ridewithgps.com' + objectUrl)}`}>
              <Icon i={'twitter-icon'} title={'Share on twitter'} />
            </a>
            <a className={styles.icon} href='#' onClick={this.onClickEmail}>
              <Icon i={'email-icon'} />
            </a>
          </div>

          <CTA secondary={!copySuccess} margins onClick={this.onClickCopy}>
            {copySuccess ? 'Copied!' : <React.Fragment><Icon i={'md-link'} size={20} className={styles.ctaIcon} /> Copy Link</React.Fragment>}
          </CTA>

          {EMBEDDABLES.includes(objectType) && objectId &&
            <CTA secondary margins target='_blank' href={urls.embeds.new(objectId, objectType, privacyCode)}>
              <Icon i='md-code' size={20} className={styles.ctaIcon} /> Get Custom Embed
            </CTA>}
        </div>
      </ModalOverlay>
    )
  }
}

class EmailShare extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      shareSuccess: null,
      error: null,
      sharePending: false
    }
  }

  onChangeEmail = (e) => {
    this.setState({email: e.target.value})
  }

  onSubmit = (e) => {
    e.preventDefault()
    const {id, type, url} = this.props
    const {email, sharePending} = this.state
    if (sharePending) { return }
    const share = {
      id,
      model: type,
      url: 'https://ridewithgps.com' + url,
      email
    }
    this.setState({sharePending: true})
    fetchJSON('/share', {share})
      .then(() => {
        this.setState({sharePending: false, shareSuccess: true, error: null})
      })
      .catch(() => {
        this.setState({sharePending: false, shareSuccess: false, error: 'Oops - something went wrong. Please try again.'})
      })
  }

  render () {
    const {email, error, sharePending, shareSuccess} = this.state

    return (
      <div className={styles.EmailShare}>
        {error && <p>{error}</p>}
        <form onSubmit={this.onSubmit}>
          <label>Email address to share with</label>
          <input type='email' value={email} onChange={this.onChangeEmail} />
          {!shareSuccess && <CTA button type='submit'>
            {sharePending ? <CircleSpinner size={14} /> : 'Email Link'}
          </CTA>}
          {shareSuccess && <CTA disabled>Link Sent</CTA>}
        </form>
      </div>
    )
  }
}
